module.exports = __webpack_public_path__ + "fonts/YekanBakhFaNumRegular.76efaa5.ttf";